module.exports = __webpack_public_path__ + "img/Baisc_raw_numbers-300x122.65ecdcaf.png";